// DateTimeCell.js
import React from "react";

const DateTimeCell = ({ value }) => {
  if (!value) return null;

  const dateObj = new Date(value);

  // Format date as YYYY-MM-DD
  const dateStr = dateObj.toISOString().split("T")[0];

  // Format time as hh:mm AM/PM
  const timeStr = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div className="flex flex-col text-xs h-full w-full justify-center items-start">
      <span className="font-medium">{dateStr}</span>
      <span className="text-gray-500">{timeStr}</span>
    </div>
  );
};

export default DateTimeCell;
